<template>
  <CountryPage country="saudi_arabia" />
</template>